import React, { useEffect, useState, useRef, createRef, RefObject } from 'react';
import GetTaxpayerInfo from '../../Taxpayer/components/GetTaxpayerInfo';
import {
  Card,
  Form,
  Divider,
  Typography,
  Row,
  Col,
  Select,
  Input,
  Button,
  message,
  Checkbox,
  Tooltip,
  InputNumber,
  DatePicker,
} from 'antd';
import { useWindowDimensions } from '../../../utils/hooks';
import { useParams, useHistory } from 'react-router';
import { States, State, Taxpayer } from 'sigt';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import MultipleTransactions from '../../Forms/components/MultipleTransactions';
import axios from 'axios';
import { round } from 'lodash';
import { from } from 'rxjs';
import { CloudDownloadOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
const server = process.env.REACT_APP_SERVER_URL;

const MineralSettlements: React.FC<MineralSettlementsProps> = ({ thm, branches, banks, institutions, auth }) => {
  const [data, setData] = useState<any>({});
  const [sectors, setSectors] = useState<any>([]);
  const [selectedSector, setSelectedSector] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [appMonto, setAppMonto] = useState(0);
  const [metros, setMetros] = useState(0);
  const [folios, setFolios] = useState(0);
  const [kilos, setKilos] = useState(0);
  const [unidades, setUnidades] = useState(0);
  const [hect, setHect] = useState(1);
  const [montod, setMontoD] = useState(1);
  const [esVigente, setEsVigente] = useState(true);
  const [ramoTitle, setRamoTitle] = useState('Seleccione un propósito');
  const [blockMonto, setBlockMonto] = useState(false);
  const [hideSub, setHideSub] = useState(false);
  const [files, setFiles] = useState<{ [P: string]: File } | null>(null);
  const [filesPago, setFilesPago] = useState<{ [P: string]: File } | null>(null);

  const { width } = useWindowDimensions();
  const { id } = useParams<{ id: any }>();
  const history = useHistory();
  const [form] = Form.useForm();

  const selectedInstitution = institutions?.find((i) => i.id === 9);
  const petro = useSelector((state: State) => state.coin.petro);
  const ut = useSelector((state: State) => state.ut.ut);
  const dolar = useSelector((state: State) => state.coin.dolar);
  const euro = useSelector((state: State) => state.coin.euro);
  const moneda = useSelector((state: State) => state.coin.moneda);
  

  const taxPayer: Taxpayer = (history.location.state as any)?.contribuyente || auth?.user?.contribuyente;
  // const showAll = auth.user?.institucion?.id === 9;
  const showAll = true;
  const cpuBranches = ['111', '123', '124'];
  const sectoresTalonarios = [51, 52, 53, 54, 55];

  const tasasMineralesExtraccion = [
    { nombre: 'Carbon', tasa: 3 },
    { nombre: 'Marmol', tasa: 0.7 },
    { nombre: 'Cuarzo', tasa: 2.45 },
  ];

  const recaudosMinerales = [
    {
      nombreCompleto: 'Soporte 1',
      nombreCorto: 'Soporte 1',
      id: 1,
      fisico: false,
      obligatorio: true,
      extension: 'pdf',
    },
    {
      nombreCompleto: 'Soporte 2',
      nombreCorto: 'Soporte 2',
      id: 2,
      fisico: false,
      obligatorio: true,
      extension: 'pdf',
    },
    {
      nombreCompleto: 'Soporte 3',
      nombreCorto: 'Soporte 3',
      id: 3,
      fisico: false,
      obligatorio: true,
      extension: 'pdf',
    },
    {
      nombreCompleto: 'Soporte 4',
      nombreCorto: 'Soporte 4',
      id: 4,
      fisico: false,
      obligatorio: true,
      extension: 'pdf',
    },
  ];

  const recaudosRef = useRef<RefObject<HTMLImageElement>[]>([]);
  const refs = useRef<any>([]);

  const recaudosMineral = [
    {
      nombreCompleto: 'Prueba 1',
      nombreCorto: 'Documento1',
      id: 1,
      fisico: false,
      obligatorio: true,
      extension: 'pdf',
    },
    {
      nombreCompleto: 'Nombre Prueba 2',
      nombreCorto: 'Documento2',
      id: 2,
      fisico: false,
      obligatorio: false,
      extension: 'pdf',
    },
  ];

  useEffect(() => {
    if (recaudosMineral?.length > recaudosRef.current?.length) {
      let diff = recaudosMineral?.length - recaudosRef.current?.length;
      for (let i = 0; i < diff; i++) {
        recaudosRef.current.push(createRef<HTMLImageElement>());
      }
    } else if (recaudosMineral?.length < recaudosRef.current?.length) {
      let diff = recaudosRef.current?.length - recaudosMineral?.length;
      for (let i = 0; i < diff; i++) {
        recaudosRef.current.splice(-1, 1);
      }
    }
  }, [form]);

  const handleFiles = (e, name: string, i: number) => {
    const file = e.target.files[0];
    if (file) {
      const fr = new FileReader();
      const blob = (file as File).slice(0, (file as File).size, file.type);
      setFiles({
        ...files,
        [name]: new File([blob], `${name}.${file.name.split('.')[file.name.split('.').length - 1]}`, { type: file.type }),
      });
      fr.readAsDataURL(file);
      fr.onload = (e) => {
        if (file.type.includes('image')) recaudosRef.current[i]?.current?.setAttribute('src', e.target?.result?.toString() || '');
        else if (file.type.includes('excel')) {
          recaudosRef.current[i]?.current?.setAttribute('src', require('../../../assets/images/excel.png'));
          recaudosRef.current[i]?.current?.style.setProperty('width', '80px');
          recaudosRef.current[i]?.current?.style.setProperty('height', '80px');
        } else if (file.type.includes('pdf')) {
          recaudosRef.current[i]?.current?.setAttribute('src', require('../../../assets/images/pdf.png'));
          recaudosRef.current[i]?.current?.style.setProperty('width', '80px');
          recaudosRef.current[i]?.current?.style.setProperty('height', '80px');
        } else {
          recaudosRef.current[i]?.current?.setAttribute('src', require('../../../assets/images/file.png'));
          recaudosRef.current[i]?.current?.style.setProperty('width', '80px');
          recaudosRef.current[i]?.current?.style.setProperty('height', '80px');
        }
      };
    }
  };

  const deleteFile = (name: string, i: number) => {
    const _files = Object.assign({}, files);
    delete _files[name];
    setFiles(_files);
    recaudosRef.current[i] = createRef();
  };

  useEffect(() => {
    if (auth?.user?.tipoUsuario === 4 && !id) {
      if (auth?.user?.contribuyente?.id) {
        history.push(`/dashboard/impuestos/minerales/${auth?.user?.contribuyente?.id}`);
      } else {
        history.push('/dashboard');
      }
    }
  }, []);

  // useEffect(() => {
  //   if (auth?.user?.tipoUsuario !== 4) {
  //     setEsVigente(false);
  //   }
  // }, []);

  useEffect(() => {
    handleGetBranchSector();
  }, []);

  const resetCounters = () => {
    setMetros(0);
    setHect(0);
    setFolios(0);
    setUnidades(0);
    setKilos(0);
    setMontoD(0);
    setAppMonto(0);
  };

  useEffect(() => {
    form.setFieldsValue({ ramo: '' });
    form.setFieldsValue({ subramo: '' });
    form.setFieldsValue({ aplicacion: '' });
    form.setFieldsValue({ ut: 0 });
    form.setFieldsValue({ monto: 0 });
    form.setFieldsValue({ metros: 0 });
    form.setFieldsValue({ folios: 0 });
    form.setFieldsValue({ kilos: 0 });
    form.setFieldsValue({ hect: 0 });
    form.setFieldsValue({ unidades: 0 });
    setData({
      ...data,
      ramo: '',
      subramo: '',
      aplicacion: '',
      ut: 0,
      monto: 0,
      metros: 0,
      folios: 0,
      kilos: 0,
      hect: 0,
      unidades: 0,
    });
    setBlockMonto(false);
    resetCounters();
  }, [selectedSector]);

  useEffect(() => {
    form.setFieldsValue({ subramo: '' });
    form.setFieldsValue({ aplicacion: '' });
    form.setFieldsValue({ ut: 0 });
    setData({ ...data, subramo: '', aplicacion: '', ut: 0 });
    resetCounters();
  }, [data.ramo]);

  useEffect(() => {
    if (!(history.location.state as any)?.contribuyente || (history.location.state as any)?.contribuyente?.id !== id) {
      history.push('/dashboard/impuestos/minerales');
    }
    if (auth.user?.institucion?.nombreCorto !== 'SAGAS' && auth.user?.institucion?.nombreCompleto !== 'CPU') {
      history.goBack();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (data.ramo) {
      let montoFoliosUT = folios ? 2 + (folios - 1) : 0;
      let montoFoliosBs = round(montoFoliosUT * round((petro * ut) / 100, 2), 2);
      let bran = branches.find((b) => b.id === data.ramo);
      setRamoTitle(bran?.descripcion || 'Seleccione un propósito');
      if ((data.ramo >= 509 && data.ramo <= 514) || data?.ramo === 499 || data?.ramo === 500) {
        form.setFieldsValue({ monto: round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2) });
        setBlockMonto(true);
      } else if (data?.ramo === 1108) {
        let periodos = data.periodos;
        console.log('extraccion 2');
        console.log(data);
        console.log(periodos);
        let montos = periodos
          ? round(
              periodos?.reduce((prev, current) => prev + current?.montod, 0),
              2
            ) || 0
          : 0;
        console.log(montos);
        let montod = round(montos * 0.03, 2);
        form.setFieldsValue({ monto: montod, ut: round(round(montod, 2) * round(100 / (petro * ut), 2)) });
        setBlockMonto(true);
      } else if (data?.ramo === 1107) {
        let controles = data.controles;
        console.log('procesamiento 3');
        console.log(data);
        console.log(controles);
        let montos = controles
          ? round(
              controles?.reduce(
                (prev, current) =>
                  prev +
                  Number(current?.cantidad) * (tasasMineralesExtraccion.find((f) => f.nombre === current?.mineral)?.tasa || 0),
                0
              ),
              2
            ) || 0
          : 0;
        console.log(montos);
        let montod = round(montos, 2);
        form.setFieldsValue({ monto: montod, ut: round(round(montod, 2) * round(100 / (petro * ut), 2)) });
        setBlockMonto(true);
      } else if (data?.ramo === 1110) {
        console.log(`Talonarios ${folios}`);
        console.log(`bran: ${bran}`);
        let montoTalonarios = round(Math.ceil(Number(folios || 0)) * (50 * (moneda.toLocaleLowerCase() === 'euro' ? euro : dolar)), 8);
        let montoTalonariosUT = round(round(montoTalonarios || 0, 2) * round(100 / (petro * ut), 2));
        console.log(`Monto talonario ${montoTalonarios}`);
        console.log(`Monto talonario ut ${montoTalonariosUT}`);
        form.setFieldsValue({ monto: montoTalonarios, ut: montoTalonariosUT });
        setBlockMonto(true);
      } else if (appMonto && appMonto > 0) {
        form.setFieldsValue({ monto: appMonto });
        setBlockMonto(true);
        form.setFieldsValue({ ut: round(round(appMonto || 0, 2) * round(100 / (petro * ut), 2)) });
      } else {
        if (data.subramo) {
          let subr = bran?.subramos?.find((s) => s.id === data.subramo);
          if (!subr?.monto) {
            form.setFieldsValue({ monto: round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2) });
            setBlockMonto(true);
          } else {
            form.setFieldsValue({
              monto:
                subr?.monto && subr?.monto > 0
                  ? round(
                      subr?.monto * (metros ? metros : 1) * (hect ? hect : 1) * (kilos ? kilos : 1) * (unidades ? unidades : 1),
                      2
                    )
                  : 0,
              // (
              // subr.descripcion.includes('hectáreas') ? round((bran?.subramos[0]?.monto || 0),2) + round( (subr?.monto * (hect - 1)) ,2)
              // : round(subr?.monto * (metros ? metros : 1),2) ) : 0
            });
            setBlockMonto(subr?.monto && subr?.monto > 0 ? true : false);
            form.setFieldsValue({
              ut:
                (subr?.montout && subr?.montout > 0
                  ? subr?.montout
                  : round(round(subr?.monto || 0, 2) * round(100 / (petro * ut), 2))) *
                (metros ? metros : 1) *
                (hect ? hect : 1) *
                (kilos ? kilos : 1) *
                (unidades ? unidades : 1),
            });
          }
        } else {
          if ((bran?.subramos?.length || 0) > 0) {
            form.setFieldsValue({ monto: 0 });
            setBlockMonto(false);
            form.setFieldsValue({ ut: 0 });
          } else {
            if (!bran?.monto) {
              form.setFieldsValue({ monto: round((form.getFieldValue('ut') || 0) * round((petro * ut) / 100, 2), 2) });
              setBlockMonto(true);
            } else {
              form.setFieldsValue({
                monto:
                  bran?.monto && bran?.monto > 0
                    ? round(
                        bran?.monto *
                          (metros ? metros : 1) *
                          (hect ? hect : 1) *
                          (kilos ? kilos : 1) *
                          (unidades ? unidades : 1) *
                          (montod ? montod / 100 : 1) +
                          montoFoliosBs,
                        2
                      )
                    : 0,
              });
              setBlockMonto(bran?.monto && bran?.monto > 0 ? true : false);
              form.setFieldsValue({
                ut:
                  (bran?.montout && bran?.montout > 0
                    ? bran?.montout
                    : round(round(bran?.monto || 0, 2) * round(100 / round(petro * ut, 2), 2))) *
                    (metros ? metros : 1) *
                    (hect ? hect : 1) *
                    (kilos ? kilos : 1) *
                    (unidades ? unidades : 1) *
                    (montod ? montod / 100 : 1) +
                  montoFoliosUT,
              });
            }
          }
        }
      }
    } else {
      setRamoTitle('Seleccione un propósito');
    }
  }, [
    branches,
    data.ramo,
    data.subramo,
    montod,
    metros,
    kilos,
    unidades,
    hect,
    folios,
    appMonto,
    data.ut,
    data.periodos,
    data.controles,
  ]);

  const handleAppChange = (id) => {
    const appM = branches.find((b) => b.id === data.ramo)?.aplicaciones?.find((b) => b.id === id)?.monto;
    if (appM) {
      setAppMonto(appM);
    } else {
      setAppMonto(0);
    }
  };

  const submit = async () => {
    let values = await form.validateFields();
    const checkF = (i) => {
      return filesPago ? filesPago.hasOwnProperty(`Comprobante${i + 1}`) : false;
    };
    let notP: Array<any> = [];
    if (values.pagos && values.pagos?.length > 0) {
      values.pagos.map((p, i) => {
        p.i = i;
        p.idInstitucionBanco = p.destino;
        p.destino = banks?.find(
          (b) => b.id === selectedInstitution?.cuentasBancarias?.find((c) => c.id === p.destino)?.banco
        )?.id;
        return p;
      });
      let filterP = values.pagos?.filter((p) => p.metodoPago !== 'PUNTO DE VENTA');
      if (filterP && filterP.length > 0) {
        filterP.map((p, i) => {
          p.check = checkF(p.i);
          notP.push(p);
        });
      }
    }
    const hasAllMandatoryTakings =
      auth?.user?.tipoUsuario === 4
        ? esVigente
          ? true
          : notP && notP?.length > 0
          ? !notP.some((p, i) => p.check === false)
          : true
        : true;
    const ingresado = esVigente
      ? 0
      : round(
          values.pagos?.reduce((prev, current) => prev + current.costo, 0),
          2
        );
    console.log(esVigente, 'VIGENTE');
    console.log(ingresado, 'ingresado');
    console.log(round(values.monto, 2), 'rounded');
    if (!esVigente && round(values.monto, 2) > ingresado) {
      message.error('El monto de los pagos debe ser igual o mayor al monto de la liquidación');
    } else if (!hasAllMandatoryTakings) {
      message.error('Debe ingresar un comprobante por cada pago');
    } else {
      if (values.subramo === '') {
        delete values.subramo;
      }
      if (values.aplicacion === '') {
        delete values.aplicacion;
      }
      const ramo = (showAll ? branches : branches.filter((b) => cpuBranches.includes(b.codigo || '')))
        .filter((b) => b.liquidacionEspecial)
        .filter((b) => b.sectorID === sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo)
        .filter((element) => element.descripcion === values.ramo)[0]?.id;
      values.fechaCancelada = moment(new Date(), 'DD/MM/YYYY');
      values.fechaCancelada = {
        month: values.fechaCancelada.locale('es').format('MMMM'),
        year: parseInt(values.fechaCancelada.locale('es').format('YYYY')),
      };
      values.monto = +(+values.monto / petro).toFixed(8);
      values.impuestos = [
        {
          fechaCancelada: values.fechaCancelada,
          ramo: ramo,
          subramo: values.subramo,
          monto: values.monto,
          aplicacion: values.aplicacion,
        },
      ];
      values.tipoDocumento = taxPayer.tipoDocumento;
      values.documento = taxPayer.documento;
      values.tipoContribuyente = taxPayer.tipoContribuyente;
      values.rim = values.rim ? values.rim : taxPayer.documento;
      if (!esVigente) {
        values.pagos
          ?.filter((p) => p)
          .forEach((p) => {
            Object.keys(p).forEach((k) => {
              if (moment.isMoment(p[k])) {
                p[k] = p[k].toISOString();
              }
            });
          });
      }
      if (values.pagos) {
        for (let i = 0; i < values.pagos.length; i++) {
          values.pagos[i] = { ...values.pagos[i], id_usuario: auth?.user?.id };
        }
      }
      values.esVigente = esVigente;
      values.esMineral = true;
      // delete values.metros;
      // delete values.sector;
      // delete values.ut;
      // delete values.unidades;
      setLoading(true);
      try {
        const response = await axios.post(`${server}/settlements/special`, values, {
          headers: { Authorization: `Bearer ${auth.token}` },
        });
        const fd = new FormData();
        let fileCount = 0;
        if (filesPago)
          Object.keys(filesPago).forEach((k) => {
            fd.append('recaudos', filesPago[k]);
            fileCount++;
          });
        if (fileCount > 0) {
          const resp = await axios.post(`${server}/uploads/special/support/${response.data?.solicitud?.id}`, fd, {
            headers: { Authorization: `Bearer ${auth.token}` },
          });
        }

        const fd2 = new FormData();
        let fileCount2 = 0;
        if (files)
          Object.keys(files).forEach((k) => {
            fd2.append('recaudos', files[k]);
            fileCount2++;
          });
        console.log(fileCount2);
        if (fileCount2 > 0) {
          const resp = await axios.post(`${server}/uploads/mineral/support/${response.data?.solicitud?.id}`, fd2, {
            headers: { Authorization: `Bearer ${auth.token}` },
          });
        }

        message.success('Liquidación creada de manera exitosa');
        if (auth?.user?.tipoUsuario !== 4) history.push('/dashboard/impuestos/minerales');
        else history.push('/dashboard');
        if (response.status === 201 && response.data.solicitud.recibo) {
          const win = window.open(response.data.solicitud.recibo, '_blank');
          win?.focus();
        }
        form.resetFields();
        history.push('/dashboard/impuestos/pagar');
      } catch (e) {
        message.error(e.response?.data?.message || 'Error al crear liquidación');
      } finally {
        setLoading(false);
      }
    }
  };

  const firstListItem = (fields, add) => {
    if (fields.length === 0) {
      add();
    }
  };

  const handleGetBranchSector = async () => {
    try {
      const response = await axios.get(`${server}/branches/sectors`, { headers: { Authorization: `Bearer ${auth.token}` } });
      setSectors(response.data.data.sectors);
    } catch (e) {
      message.error('No se pudieron obtener los sectores');
    }
  };

  return (
    <Card
      style={{ height: '100%' }}
      title='Minerales no Metálicos'
      bodyStyle={{ height: 'calc(100% - 88px)', overflowY: 'scroll', overflowX: 'hidden', border: '1px solid #f0f0f0' }}
      headStyle={{ height: 64, backgroundColor: thm.primaryColor, padding: width < 1200 ? '0 10px' : '0 20px', color: 'white' }}
    >
      {!id && <GetTaxpayerInfo />}
      {id && (
        <Form
          form={form}
          layout='vertical'
          onFinish={submit}
          scrollToFirstError
          onValuesChange={(c, v) => {
            const ramo = (showAll ? branches : branches.filter((b) => cpuBranches.includes(b.codigo || '')))
              .filter((b) => b.liquidacionEspecial)
              .filter((b) => b.sectorID === sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo)
              .filter((element) => element.descripcion === v.ramo)[0]?.id;
            form.setFieldsValue(v);
            setData({ ...v, ramo });
          }}
        >
          {(auth?.user?.tipoUsuario !== 4 ||
            (auth?.user?.tipoUsuario === 4 && (auth?.user?.contribuyente?.sucursales?.length || 0) > 1)) && (
            <Divider orientation='left' style={{ marginLeft: -20, marginBottom: 0 }}>
              <Typography.Title ellipsis level={4} style={{ marginLeft: 5 }}>
                Sucursal
              </Typography.Title>
            </Divider>
          )}
          {(auth?.user?.tipoUsuario !== 4 ||
            (auth?.user?.tipoUsuario === 4 && (auth?.user?.contribuyente?.sucursales?.length || 0) > 1)) && (
            <Row gutter={24}>
              <Col xs={24} xl={24}>
                <Form.Item label='Sucursal' name='rim' rules={[{ required: false, message: 'Debe ingresar la sucursal' }]}>
                  <Select placeholder='Seleccione la sucursal'>
                    {taxPayer?.sucursales?.map((s) => (
                      <Select.Option value={s.referenciaMunicipal} key={s.id}>
                        {s.referenciaMunicipal} - {s.denomComercial} - {s.email} - {s.nombreRepresentante} - {s.direccion}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          )}
          <Divider orientation='left' style={{ marginLeft: -20, marginBottom: 0 }}>
            <Typography.Title ellipsis level={4} style={{ marginLeft: 5 }}>
              Minerales no Metálicos
            </Typography.Title>
          </Divider>
          <Row gutter={24}>
            <Col xs={24} xl={24}>
              <Form.Item
                label='Seleccione una categoría'
                name='sector'
                rules={[{ required: true, message: 'Debe seleccionar una categoría' }]}
              >
                <Select placeholder='Seleccione una categoría' showSearch onChange={(value) => setSelectedSector(value)}>
                  {sectors
                    .filter((s) => s.id_sector_ramo === 20)
                    .map((b) => (
                      <Select.Option value={b.descripcion} key={b.id_sector_ramo}>
                        {b.descripcion}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} xl={24}>
              <Tooltip title={ramoTitle}>
                <Form.Item
                  label='Seleccione timbre fiscal requerido'
                  name='ramo'
                  rules={[{ required: true, message: 'Debe ingresar el propósito' }]}
                >
                  <Select placeholder='Seleccione un propósito' showSearch>
                    {(showAll ? branches : branches.filter((b) => cpuBranches.includes(b.codigo || '')))
                      .filter((b) => b.liquidacionEspecial)
                      .filter((b) => b.sectorID === sectors.find((s) => s.descripcion === selectedSector)?.id_sector_ramo)
                      .map((b) => (
                        <Select.Option value={b.descripcion} key={b.id}>
                          {b.descripcion}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Tooltip>
            </Col>
            {data.ramo && data.ramo !== '' && (branches.find((b) => b.id === data.ramo)?.aplicaciones?.length || 0) > 0 && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Aplicación del timbre'
                  name='aplicacion'
                  rules={[{ required: true, message: 'Debe escoger una aplicación para el timbre' }]}
                >
                  <Select placeholder='Seleccione una aplicación para el timbre' onChange={(e) => handleAppChange(e)}>
                    {branches
                      .find((b) => b.id === data.ramo)
                      ?.aplicaciones?.map((b) => (
                        <Select.Option value={b.id} key={b.id}>
                          {b.descripcion}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
            {data.ramo &&
              data.ramo !== '' &&
              appMonto === 0 &&
              (branches.find((b) => b.id === data.ramo)?.subramos?.length || 0) > 0 && (
                <Col xs={24} xl={16}>
                  <Form.Item
                    label='Caso Específico'
                    name='subramo'
                    rules={[{ required: true, message: 'Debe ingresar caso específico' }]}
                  >
                    <Select placeholder='Seleccione un caso específico'>
                      {branches
                        .find((b) => b.id === data.ramo)
                        ?.subramos?.map((b) => (
                          <Select.Option value={b.id} key={b.id}>
                            {b.descripcion}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
            {((data.ramo &&
              (branches.find((b) => b.id === data.ramo)?.descripcion?.includes('m2') ||
                branches.find((b) => b.id === data.ramo)?.descripcion?.includes('m3'))) ||
              (data.ramo &&
                (branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('m2') ||
                  branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('m3')))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Metros'
                  name='metros'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de metros' }]}
                >
                  <InputNumber
                    placeholder='Metros'
                    onChange={(value) => setUnidades(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {((data.ramo && branches.find((b) => b.id === data.ramo)?.descripcion?.includes('mts')) ||
              (data.ramo && branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('mts'))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Metros Lineales'
                  name='metros'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de metros lineales' }]}
                >
                  <InputNumber
                    placeholder='Metros lineales'
                    onChange={(value) => setMetros(value ? Math.ceil(value / 500) : 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {((data.ramo &&
              (branches.find((b) => b.id === data.ramo)?.descripcion?.includes('x kilo') ||
                branches.find((b) => b.id === data.ramo)?.descripcion?.includes('x kilo'))) ||
              (data.ramo &&
                (branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('x kilo') ||
                  branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('x kilo')))) && (
              <Col xs={24} xl={16}>
                <Form.Item label='Kilos' name='kilos' rules={[{ required: true, message: 'Debe ingresar la cantidad de kilos' }]}>
                  <InputNumber
                    placeholder='Kilos'
                    onChange={(value) => setKilos(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {((data.ramo && branches.find((b) => b.id === data.ramo)?.descripcion?.includes('x unidad')) ||
              (data.ramo && branches.find((b) => b.id === data.ramo)?.subramos[0]?.descripcion?.includes('x unidad'))) && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Unidades'
                  name='unidades'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de unidades autorizadas' }]}
                >
                  <InputNumber
                    placeholder='Unidades'
                    onChange={(value) => setMetros(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {data.ramo &&
              data.subramo &&
              branches
                .find((b) => b.id === data.ramo)
                ?.subramos.find((s) => s.id === data.subramo)
                ?.descripcion?.includes('hectárea') && (
                <Col xs={24} xl={16}>
                  <Form.Item
                    label='Hectáreas'
                    name='hect'
                    rules={[{ required: true, message: 'Debe ingresar la cantidad de hectáreas' }]}
                  >
                    <InputNumber
                      placeholder='Hectáreas'
                      onChange={(value) => setHect(value || 0)}
                      defaultValue={1}
                      min={1}
                      // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
              )}
            <Col xs={24} xl={16}>
              <Form.Item
                label='Nro de Licencia'
                name='licencia'
                rules={[{ required: true, message: 'Debe ingresar el nro de licencia' }]}
              >
                <Input placeholder='Nro de Licencia' style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            {data && data.ramo === 1110 && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Nro de Planilla'
                  name='nroplanilla'
                  rules={[{ required: true, message: 'Debe ingresar el nro de planilla' }]}
                >
                  <Input placeholder='Nro de Planilla' style={{ width: '100%' }} />
                </Form.Item>
              </Col>
            )}
            {data.ramo && data.ramo === 1110 && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Talonarios'
                  name='talonarios'
                  rules={[{ required: true, message: 'Debe ingresar la cantidad de talonarios (Puede ser 0)' }]}
                >
                  <InputNumber
                    placeholder='Talonarios'
                    onChange={(value) => setFolios(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            )}
            {data.ramo && branches.find((b) => b.id === data.ramo)?.descripcion?.includes('%') && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Monto a declarar'
                  name='montod'
                  rules={[{ required: true, message: 'Debe ingresar el monto a declarar' }]}
                >
                  <InputNumber
                    placeholder='Monto a declarar'
                    onChange={(value) => setMontoD(value || 0)}
                    // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                    style={{ width: '100%', fontSize: 18 }}
                  />
                </Form.Item>
              </Col>
            )}
            {data.ramo && data.ramo === 498 && (
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Descripción del caso'
                  name='desc'
                  rules={[{ required: true, message: 'Debe especificar la descripción del caso' }]}
                >
                  <Input placeholder='Descripción' />
                </Form.Item>
              </Col>
            )}
            {data.ramo && data.ramo === 1108 && (
              <Col xs={24} xl={24}>
                <Form.List name='periodos'>
                  {(fields, { add, remove }) => (
                    <div>
                      {firstListItem(fields, add)}
                      {fields.map((field, index) => {
                        return (
                          <React.Fragment key={field.key}>
                            <Divider style={{ margin: 5, marginLeft: -5 }} orientation='left'>
                              <Typography.Text strong style={{ marginLeft: 5 }}>
                                Periodo {index + 1}
                              </Typography.Text>
                            </Divider>
                            <Form.Item required key={field.key} style={{ width: '100%', margin: 0 }}>
                              <Row gutter={24} style={{ padding: '0 20px' }}>
                                <Col xs={24} xl={8}>
                                  <Form.Item
                                    label='Fecha de inicio'
                                    name={[field.name, 'inicio']}
                                    fieldKey={field.fieldKey}
                                    rules={[{ required: true, message: 'Por favor ingrese la fecha de inicio.' }]}
                                  >
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      format={'DD-MM-YYYY'}
                                      disabledDate={(current) => current > moment().endOf('day')}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} xl={8}>
                                  <Form.Item
                                    label='Fecha de fin'
                                    name={[field.name, 'fin']}
                                    fieldKey={field.fieldKey}
                                    rules={[{ required: true, message: 'Por favor ingrese la fecha de fin.' }]}
                                  >
                                    <DatePicker
                                      style={{ width: '100%' }}
                                      format={'DD-MM-YYYY'}
                                      disabledDate={(current) => current > moment().endOf('day')}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} xl={8}>
                                  <Form.Item
                                    label='Monto declarado'
                                    name={[field.name, 'montod']}
                                    fieldKey={field.fieldKey}
                                    rules={[{ required: true, message: 'Por favor ingrese el monto del periodo.' }]}
                                  >
                                    <InputNumber
                                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                      parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                                      min={0}
                                      step={1}
                                      style={{ width: '100%' }}
                                      placeholder='Monto'
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Form.Item>
                          </React.Fragment>
                        );
                      })}
                      <Row gutter={[16, 16]} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {fields.length > 1 && (
                          <Col>
                            <Button type='danger' onClick={() => remove(fields.length - 1)}>
                              Eliminar Periodo
                            </Button>
                          </Col>
                        )}
                        <Col>
                          <Button type='dashed' onClick={() => add()}>
                            Agregar Periodo
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Form.List>
              </Col>
            )}
            {data.ramo && data.ramo === 1107 && (
              <Col xs={24} xl={24}>
                <Form.List name='controles'>
                  {(fields, { add, remove }) => (
                    <div>
                      {firstListItem(fields, add)}
                      {fields.map((field, index) => {
                        return (
                          <React.Fragment key={field.key}>
                            <Divider style={{ margin: 5, marginLeft: -5 }} orientation='left'>
                              <Typography.Text strong style={{ marginLeft: 5 }}>
                                Control de Volumen {index + 1}
                              </Typography.Text>
                            </Divider>
                            <Form.Item required key={field.key} style={{ width: '100%', margin: 0 }}>
                              <Row gutter={24} style={{ padding: '0 20px' }}>
                                <Col xs={24} xl={12}>
                                  <Form.Item
                                    label='Categoría'
                                    name={[field.name, 'mineral']}
                                    fieldKey={field.fieldKey}
                                    rules={[{ required: true, message: 'Por favor ingrese el mineral no metalico.' }]}
                                  >
                                    <Select placeholder='Seleccione el mineral '>
                                      {tasasMineralesExtraccion?.map((t, i) => (
                                        <Select.Option value={t.nombre} key={i}>
                                          {t.nombre}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col xs={24} xl={12}>
                                  <Form.Item
                                    label='Cantidad (metros cubicos)'
                                    name={[field.name, 'cantidad']}
                                    fieldKey={field.fieldKey}
                                    rules={[{ required: true, message: 'Por favor ingrese la cantidad.' }]}
                                  >
                                    <InputNumber
                                      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                      parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                                      min={0}
                                      step={1}
                                      style={{ width: '100%' }}
                                      placeholder='Cantidad'
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Form.Item>
                          </React.Fragment>
                        );
                      })}
                      <Row gutter={[16, 16]} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {fields.length > 1 && (
                          <Col>
                            <Button type='danger' onClick={() => remove(fields.length - 1)}>
                              Eliminar Control de Volumen
                            </Button>
                          </Col>
                        )}
                        <Col>
                          <Button type='dashed' onClick={() => add()}>
                            Agregar Control de Volumen
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  )}
                </Form.List>
              </Col>
            )}
            {data && [1107, 1108].includes(data.ramo) && (
              <Divider orientation='left' style={{ marginLeft: -30 }}>
                <Typography.Title level={4}>Archivos a Subir</Typography.Title>
              </Divider>
            )}
            {data && [1107, 1108].includes(data.ramo) && (
              <Row gutter={24}>
                {recaudosMinerales
                  .sort((a, b) => (a.obligatorio === b.obligatorio ? 0 : a.obligatorio ? -1 : 1))
                  .filter((r) => !r.fisico)
                  .map((r, i) => {
                    const ref = React.createRef<HTMLInputElement>();
                    return (files && !files[r.nombreCorto]) || !files ? (
                      <Col
                        key={r.id}
                        xs={24}
                        xl={6}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column',
                          justifyContent: 'flex-start',
                          marginBottom: 20,
                        }}
                      >
                        <input
                          hidden
                          ref={ref}
                          type='file'
                          accept={r.extension}
                          onChange={(e) => handleFiles(e, r.nombreCorto, i)}
                        />
                        <Button type='primary' style={{ marginBottom: 10 }} onClick={() => ref.current?.click()}>
                          Subir Archivo
                        </Button>
                        <Typography.Text strong style={{ textAlign: 'center' }}>
                          {r.nombreCompleto + ' (jpg, jpeg, png, pdf)'}&nbsp;
                          {r.obligatorio ? <span style={{ color: 'red' }}>*</span> : ''}
                        </Typography.Text>
                      </Col>
                    ) : (
                      <Col xs={24} xl={6} key={r.id}>
                        <Card
                          cover={<img alt='recaudo' ref={recaudosRef.current[i]} />}
                          bodyStyle={{ padding: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                        >
                          <Typography.Text strong style={{ textAlign: 'center' }}>
                            {r.nombreCompleto}
                          </Typography.Text>
                          <Button
                            type='link'
                            onClick={() => deleteFile(r.nombreCorto, i)}
                            style={{ textAlign: 'right', width: '100%', color: 'red' }}
                          >
                            Eliminar
                            <DeleteOutlined />
                          </Button>
                        </Card>
                      </Col>
                    );
                  })}
              </Row>
            )}
            {/* <Col xs={24} xl={8}>
              <Form.Item
                label='Cantidad de Talonarios'
                name='talonarios'
                rules={[{ required: true, message: 'Debe ingresarla cantidad de talonarios' }]}
              >
                <InputNumber
                  placeholder='Talonarios'
                  // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                  style={{ width: '100%', fontSize: 18 }}
                />
              </Form.Item>
            </Col>
            {auth.user?.tipoUsuario !== 4 && 
              <Col xs={24} xl={16}>
                <Form.Item
                  label='Códigos de Talonarios'
                  name='codigos'
                  rules={[{ required: true, message: 'Debe incluir los códigos' }]}
                >
                  <Input.TextArea rows={4} placeholder='Códigos de Talonarios' />
                </Form.Item>
              </Col>
            } */}
            <Col xs={24} xl={8}>
              <Form.Item
                label='Monto a pagar'
                name='monto'
                rules={[{ required: true, message: 'Debe ingresar el monto de la liquidación' }]}
              >
                <InputNumber
                  placeholder='Monto'
                  disabled={blockMonto}
                  // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => (value ? value.replace(/Bs\s?|(,*)/g, '') : '')}
                  style={{ width: '100%', fontSize: 18 }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} xl={8}>
              <Form.Item label='Total MMV' name='ut'>
                <InputNumber
                  placeholder='MMV'
                  disabled={!((data?.ramo >= 509 && data?.ramo <= 514) || data?.ramo === 499 || data?.ramo === 500)}
                  // formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  // parser={value => value ? value.replace(/Bs\s?|(,*)/g, '') : ''}
                  style={{ width: '100%', fontSize: 18 }}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* {showAll && <Checkbox checked={!esVigente} onChange={(e) => setEsVigente(!e.target.checked)}>Incluir Pago</Checkbox>} */}
          {/* {showAll && auth.user?.tipoUsuario === 4 && (
            <Button type='primary' onClick={() => setEsVigente(!esVigente)}>
              {esVigente ? 'Incluir Pago' : 'No Incluir Pago'}
            </Button>
          )}
          {!esVigente && showAll && (
            <>
              <Divider orientation='left' style={{ marginLeft: -20, marginBottom: 0 }}>
                <Typography.Title ellipsis level={4} style={{ marginLeft: 5 }}>
                  Datos de Pago
                </Typography.Title>
              </Divider>
              <MultipleTransactions
                selectedInstitution={institutions?.find((i) => i.id === 9)}
                form={form}
                data={data}
                maxCred={0}
                files={filesPago}
                setFiles={setFilesPago}
                percentTax={false}
                mineralTax={true}
                taxType='mineralesRegalia'
              />
            </>
          )} */}
          <Row gutter={12} style={{ marginTop: 10, display: 'flex', justifyContent: 'space-between' }}>
            <Col>
              {auth.user?.tipoUsuario !== 4 && (
                <Button
                  onClick={() =>
                    history.push('/dashboard/impuestos/minerales', {
                      contribuyentes: (history.location.state as any)?.contribuyentes,
                    })
                  }
                >
                  Atrás
                </Button>
              )}
            </Col>
            <Row gutter={12}>
              <Col>
                <Button loading={loading} type='primary' onClick={form.submit}>
                  {esVigente ? 'Liquidar' : 'Pagar'}
                </Button>
              </Col>
            </Row>
          </Row>
        </Form>
      )}
    </Card>
  );
};

const mapStateToProps = (state: State) => ({
  thm: state.thm,
  branches: state.brch.branches,
  banks: state.bk.banks,
  institutions: state.inst.institutions,
  auth: state.auth,
});

export default connect(mapStateToProps)(MineralSettlements);

interface MineralSettlementsProps {
  thm: States.ThemeColors;
  branches: States.Branches['branches'];
  banks: States.Banks['banks'];
  institutions: States.Institutions['institutions'];
  auth: States.Auth;
}
